/** @format */

import { observable, action, computed } from 'mobx';
import database from '../firebase/config';
import getTimestampFromDate from '../helpers/getTimestampFromDate';
import { getTimestamp } from '../helpers/getTimestamp';

class StatsStore {
  @observable
  stats = {
    counters: {},
    mostRequestParts: {},
    mostSoldParts: {},
    mostRequestPartsCars: {},
    mostSoldPartsCars: {},
    permissionDenied: true,
    loading: true,
    noResults: false,
    timeInterval: {
      active: true,
      start: getTimestamp(),
      end: getTimestamp() + 604800,
    },
  };

  @action
  fetchStats = () => {
    const stats = this.stats;
    const countersRef = database.ref('/stats/all/counters');
    const requestPartTypesRef = database
      .ref('/stats/all/items/requestPartTypes')
      .orderByValue()
      .limitToLast(15);
    const soldPartTypesRef = database
      .ref('/stats/all/items/soldPartTypes')
      .orderByValue()
      .limitToLast(15);
    const requestPartsAndCarsRef = database
      .ref('/stats/all/items/requestPartsAndCars')
      .orderByValue()
      .limitToLast(15);
    const soldPartsAndCarsRef = database
      .ref('/stats/all/items/soldPartsAndCars')
      .orderByValue()
      .limitToLast(15);
    stats.permissionDenied = true;

    countersRef
      .once('value', data => {
        const counters = data.val();
        stats.counters = counters;
        stats.permissionDenied = false;
        stats.loading = false;
      })
      .catch(err => {
        stats.permissionDenied = true;
        stats.loading = false;
      });

    requestPartTypesRef
      .once('value', data => {
        const mostRequestParts = data.val();
        stats.mostRequestParts = mostRequestParts;
        stats.permissionDenied = false;
        stats.loading = false;
      })
      .catch(err => {
        stats.permissionDenied = true;
        stats.loading = false;
      });

    soldPartTypesRef
      .once('value', data => {
        const mostSoldParts = data.val();
        stats.mostSoldParts = mostSoldParts;
        stats.permissionDenied = false;
        stats.loading = false;
      })
      .catch(err => {
        stats.permissionDenied = true;
        stats.loading = false;
      });

    requestPartsAndCarsRef
      .once('value', data => {
        const mostRequestPartsCars = data.val();
        stats.mostRequestPartsCars = mostRequestPartsCars;
        stats.permissionDenied = false;
        stats.loading = false;
      })
      .catch(err => {
        stats.permissionDenied = true;
        stats.loading = false;
      });

    soldPartsAndCarsRef
      .once('value', data => {
        const mostSoldPartsCars = data.val();
        stats.mostSoldPartsCars = mostSoldPartsCars;
        stats.permissionDenied = false;
        stats.loading = false;
      })
      .catch(err => {
        stats.permissionDenied = true;
        stats.loading = false;
      });
  };

  @action
  refreshStats = () => {
    const $this = this;
    $this.stats.loading = true;
    let counters = {
      counter: 0,
      sold: 0,
      unsold: 0,
      unsoldUnavailable: 0,
      soldItemsAverageValue: 0,
      soldItemsAverageCount: 0,
      active: 0,
      archived: 0,
      totalSalesValue: 0,
      maxPartPrice: 0,
      mostExpensivePart: '',
    };
    let items = {
      soldPartTypes: {},
      requestPartTypes: {},
      soldPartsAndCars: {},
      requestPartsAndCars: {},
    };

    const requestsRef = database
      .ref('/requests/')
      .orderByChild('data/timestamp/')
      .startAt(this.stats.timeInterval.start)
      .endAt(this.stats.timeInterval.end);

    requestsRef.once('value', snapshot => {
      if (snapshot.val()) {
        $this.stats.noResult = false;
        let requests = Object.values(snapshot.val());
        let soldCounts = [];
        let soldValues = [];
        requests.forEach((request, index) => {
          let reqParts = request.reqParts;
          counters.counter++;
          reqParts.forEach(part => {
            part.data.part = part.data.part
              .toString()
              .replace(/\//g, '-')
              .replace(/\./g, '-');
            part.data.carMaker = part.data.carMaker
              .toString()
              .replace(/\//g, '-')
              .replace(/\./g, '-');
            part.data.carModel = part.data.carModel
              .toString()
              .replace(/\//g, '-')
              .replace(/\./g, '-');
            if (items.requestPartTypes[part.data.part]) {
              items.requestPartTypes[part.data.part]++;
            } else {
              items.requestPartTypes[part.data.part] = 1;
            }
            if (
              items.requestPartsAndCars[
                part.data.part +
                  ' ' +
                  part.data.carMaker +
                  ' ' +
                  part.data.carModel
              ]
            ) {
              items.requestPartsAndCars[
                part.data.part +
                  ' ' +
                  part.data.carMaker +
                  ' ' +
                  part.data.carModel
              ]++;
            } else {
              items.requestPartsAndCars[
                part.data.part +
                  ' ' +
                  part.data.carMaker +
                  ' ' +
                  part.data.carModel
              ] = 1;
            }
          });
          if (request.data.progress === 'completata con vendita') {
            counters.sold++;
            let soldOptionsCount = 0;
            let soldOptionsValue = 0;
            reqParts.forEach((part, index) => {
              part.data.part = part.data.part
                .toString()
                .replace(/\//g, '-')
                .replace(/\./g, '-');
              part.data.carMaker = part.data.carMaker
                .toString()
                .replace(/\//g, '-')
                .replace(/\./g, '-');
              part.data.carModel = part.data.carModel
                .toString()
                .replace(/\//g, '-')
                .replace(/\./g, '-');
              if (typeof part !== 'undefined') {
                let options = part.options;
                if (options) {
                  options.forEach((option, index) => {
                    if (option.data.sold) {
                      counters.mostExpensivePart =
                        Number(option.data.price) > counters.maxPartPrice
                          ? part.data.part +
                            ' ' +
                            part.data.carMaker +
                            ' ' +
                            part.data.carModel
                          : counters.mostExpensivePart;

                      counters.maxPartPrice =
                        Number(option.data.price) > counters.maxPartPrice
                          ? Number(option.data.price)
                          : counters.maxPartPrice;

                      soldOptionsValue =
                        soldOptionsValue + Number(option.data.price);
                      soldOptionsCount++;
                      if (items.soldPartTypes[part.data.part]) {
                        items.soldPartTypes[part.data.part]++;
                      } else {
                        items.soldPartTypes[part.data.part] = 1;
                      }
                      if (
                        items.soldPartsAndCars[
                          part.data.part +
                            ' ' +
                            part.data.carMaker +
                            ' ' +
                            part.data.carModel
                        ]
                      ) {
                        items.soldPartsAndCars[
                          part.data.part +
                            ' ' +
                            part.data.carMaker +
                            ' ' +
                            part.data.carModel
                        ]++;
                      } else {
                        items.soldPartsAndCars[
                          part.data.part +
                            ' ' +
                            part.data.carMaker +
                            ' ' +
                            part.data.carModel
                        ] = 1;
                      }
                    }
                  });
                }
              }
              if (index === reqParts.length - 1) {
                soldCounts.push(soldOptionsCount);
                soldValues.push(soldOptionsValue);
              }
            });

            let valuesSum = soldValues.reduce(function(a, b) {
              return a + b;
            });
            let countSum = soldCounts.reduce(function(a, b) {
              return a + b;
            });
            counters.totalSalesValue = valuesSum;
            counters.soldItemsAverageCount = countSum / soldCounts.length;
            counters.soldItemsAverageValue = valuesSum / soldValues.length;
          }
          if (request.data.progress === 'completata senza vendita') {
            counters.unsold++;
          }
          if (request.data.progress === 'completata non disponibile') {
            counters.unsoldUnavailable++;
          }
          if (request.data.status === 'attiva') {
            counters.active++;
          }
          if (request.data.status === 'archiviata') {
            counters.archived++;
          }
        });
        const statsRef = database.ref('/stats/');
        statsRef
          .set({
            all: {
              counters: counters,
              items: items,
            },
          })
          .then(() => {
            $this.fetchStats();
          });
      } else {
        $this.stats.noResult = true;
        $this.stats.loading = false;
      }
    });
  };

  @action
  timeIntervalInput = (date, name) => {
    this.stats.timeInterval[name] = -getTimestampFromDate(date);
  };

  @computed
  get mostSoldParts() {
    const mostSoldPartsArr = [];
    const mostSoldParts = this.stats.mostSoldParts;
    const mostSoldPartsKeys = Object.keys(mostSoldParts);

    mostSoldPartsKeys.forEach(key => {
      mostSoldPartsArr.push({
        name: key,
        value: mostSoldParts[key],
      });
    });

    return mostSoldPartsArr
      .sort(function(a, b) {
        return a['value'] - b['value'];
      })
      .reverse();
  }

  @computed
  get mostRequestParts() {
    const mostRequestPartsArr = [];
    const mostRequestParts = this.stats.mostRequestParts;
    const mostRequestPartsKeys = Object.keys(mostRequestParts);

    mostRequestPartsKeys.forEach(key => {
      mostRequestPartsArr.push({
        name: key,
        value: mostRequestParts[key],
      });
    });

    return mostRequestPartsArr
      .sort(function(a, b) {
        return a['value'] - b['value'];
      })
      .reverse();
  }

  @computed
  get mostRequestPartsCars() {
    const mostRequestPartsCarsArr = [];
    const mostRequestPartsCars = this.stats.mostRequestPartsCars;
    const mostRequestPartsCarsKeys = Object.keys(mostRequestPartsCars);
    mostRequestPartsCarsKeys.forEach(key => {
      mostRequestPartsCarsArr.push({
        name: key,
        value: mostRequestPartsCars[key],
      });
    });

    return mostRequestPartsCarsArr
      .sort(function(a, b) {
        return a['value'] - b['value'];
      })
      .reverse();
  }

  @computed
  get mostSoldPartsCars() {
    const mostSoldPartsCarsArr = [];
    const mostSoldPartsCars = this.stats.mostSoldPartsCars;
    const mostSoldPartsCarsKeys = Object.keys(mostSoldPartsCars);
    mostSoldPartsCarsKeys.forEach(key => {
      mostSoldPartsCarsArr.push({
        name: key,
        value: mostSoldPartsCars[key],
      });
    });

    return mostSoldPartsCarsArr
      .sort(function(a, b) {
        return a['value'] - b['value'];
      })
      .reverse();
  }
}

const store = new StatsStore();

export default store;
